/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDomainEntry = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4.252 10h1.93a14.724 14.724 0 0 0-.08 4h-1.85a8.047 8.047 0 0 1 0-4zm.818-2a8.04 8.04 0 0 1 2.682-2.78c-.44.82-.827 1.76-1.125 2.78zm5.453-5.892C5.7 2.822 2 6.98 2 12c0 4.838 3.436 8.873 8 9.8v-3.054A10.545 10.545 0 0 1 8.593 16H10v-2H8.119a12.642 12.642 0 0 1 .09-4H10V8h11.168a10.002 10.002 0 0 0-10.642-5.892zM11 4.185V8H8.724c.251-.74.553-1.414.88-2 .48-.857.975-1.459 1.396-1.815zM7.597 18.68A8.04 8.04 0 0 1 5.07 16H6.5c.254.905.613 1.805 1.097 2.68zM17.348 8c-.3-1.03-.693-1.978-1.137-2.803A8.04 8.04 0 0 1 18.93 8zM13 4.206c.415.359.901.954 1.37 1.794.328.586.63 1.26.881 2H13zM22 10H12v12h10zm-2 10h-6v-8h6zm-5-7v2h4v-2zm4 6v-2h-4v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDomainEntry as DomainEntry };
